var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Two-tone/Work"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    opacity: 0.4,
    d: "M2.33673 12.8975C2.33673 12.8975 2.45506 14.3458 2.48256 14.8025C2.51923 15.415 2.7559 16.0992 3.1509 16.5742C3.7084 17.2475 4.36506 17.485 5.24173 17.4867C6.27256 17.4883 13.7684 17.4883 14.7992 17.4867C15.6759 17.485 16.3326 17.2475 16.8901 16.5742C17.2851 16.0992 17.5217 15.415 17.5592 14.8025C17.5859 14.3458 17.7042 12.8975 17.7042 12.8975",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M7.07996 4.44125V4.13208C7.07996 3.11542 7.90329 2.29208 8.91996 2.29208H11.0716C12.0875 2.29208 12.9116 3.11542 12.9116 4.13208L12.9125 4.44125",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M9.99583 13.8985V12.8202",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29156 6.99091V9.88008C3.8899 10.9342 5.8049 11.6726 7.90656 11.9651C8.15823 11.0476 8.98573 10.3751 9.99156 10.3751C10.9816 10.3751 11.8257 11.0476 12.0607 11.9734C14.1707 11.6809 16.0932 10.9426 17.6999 9.88008V6.99091C17.6999 5.57925 16.5641 4.44258 15.1524 4.44258H4.8474C3.43573 4.44258 2.29156 5.57925 2.29156 6.99091Z",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidates);
export default __webpack_public_path__ + "static/media/Candidates.1e2ddd757a385d1b5a8fd0c526cbfb63.svg";
export { ForwardRef as ReactComponent };